// The admin zone's calls (SPEC §4.13). Its session is separate from the player's: a `not-signed-in`
// reply here must not sign the player out, so these calls don't go through the player's error hook.
import api from '@/api/api';

const KEY = 'slowgo.admin';

export async function adminCall(method, url, body, params) {
  const r = await api._rest.call(method, url, body || {}, { nocheck: true, params });
  if (r.data.status !== 'success') {
    const e = new Error(r.data.message);
    e.msg = r.data.message;
    throw e;
  }
  return r.data.data;
}

export function rememberedAdminSession() {
  try { return localStorage.getItem(KEY); } catch (e) { return null; }
}

export function rememberAdminSession(id) {
  try {
    if (id) localStorage.setItem(KEY, id); else localStorage.removeItem(KEY);
  } catch (e) { /* storage unavailable */ }
}

// The admin page's sections tell each other about changes (e.g. a deleted account also leaves the
// WeChat section), so that every section shows the current state without reloading the page.
const listeners = new Set();

export function onAdminChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function adminChanged(source) {
  for (const fn of listeners) if (fn !== source) fn();
}
